var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForm2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "175px",
    width: "175px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2.33 -2.33 27.94 27.94",
    xmlSpace: "preserve",
    fill: "#2971f5",
    stroke: "#2971f5",
    strokeWidth: 0.302666,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2971f5"
    },
    d: "M20.969,1.661c-0.145,0-0.274,0.044-0.374,0.143c-0.566,0.566-9.044,9.045-9.523,9.523 l-0.004-0.004l-0.004,0.014c-0.005,0.005-0.007,0.021-0.007,0.021s-1.256,2.948-1.051,3.154c0.204,0.206,3.166-1.04,3.166-1.04 s8.792-8.791,9.546-9.546C23.365,3.277,21.853,1.661,20.969,1.661z M22.356,3.565l-9.186,9.187l-1.401-1.401 c1.679-1.678,8.672-8.673,9.173-9.176c0,0,0.008-0.004,0.027-0.004c0.357,0,1.113,0.599,1.344,1.157 C22.371,3.466,22.369,3.552,22.356,3.565z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2971f5"
    },
    d: "M16.203,11.026v7.417h-3.556v3.267l-0.048,0.044H1.935V1.528h14.268v4.019l1.529-1.529V0.764 C17.732,0.341,17.389,0,16.968,0H1.171C0.749,0,0.407,0.341,0.407,0.764v21.754c0,0.422,0.342,0.764,0.764,0.764h11.721 c0.188,0,0.369-0.07,0.51-0.194l4.076-3.648c0.162-0.145,0.254-0.352,0.254-0.569V9.498L16.203,11.026z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2971f5"
    },
    d: "M13.584,11.193c-0.048,0-0.098-0.02-0.135-0.056c-0.075-0.075-0.075-0.196,0-0.271l8.472-8.472 c0.074-0.075,0.196-0.075,0.27,0c0.075,0.075,0.075,0.196,0,0.271l-8.471,8.472C13.682,11.174,13.633,11.193,13.584,11.193z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm2);
export default __webpack_public_path__ + "static/media/form(2).2eff6684ad83d709afbfcb091600d599.svg";
export { ForwardRef as ReactComponent };